import * as signalR from "@microsoft/signalr";

const connection = new signalR.HubConnectionBuilder()
  .withUrl("/searchHub")
  .build();


connection.on("StoreResult",
  function(data) {
    callBackFunc(data);
  });

connection.on("CheckResult",
  function (data) {
    chkCallBackFunc(data);
  });

connection.onclose(async () => {
  await start();
});

export async function start()
{
  try {
    await connection.start();
  } catch (err) {
    console.log(err);
    setTimeout(() => start(), 2000);
  }
}

var callBackFunc = null;
var chkCallBackFunc = null;

export async function startSearch(what, storesToSearch, callBack) {
  callBackFunc = callBack;
  connection.invoke("SearchStore", what, storesToSearch);
}

export async function checkStores(what, storesToSearch, callBack) {
  chkCallBackFunc = callBack;
  connection.invoke("CheckStore", what, storesToSearch);
}


export class SearchService {


  constructor(method, callbackMethod, callBackFunc) {

    

    this.method = method;
    this.callbackMethod = callbackMethod;
    this.callBackFunc = callBackFunc;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl("/searchHub")
      .build();

    this.connection.on(callbackMethod, //"StoreResult"
      function (data) {
        callBackFunc(data);
      });

    this.connection.onclose(async () => {
      await this.start();
    });
  }


  async start() {
     try {
       await this.connection.start();
     } catch (err) {
       console.log(err);
       setTimeout(() => this.start(), 2000);
     }
  }

  async run(what, storesToSearch) {
    this.connection.invoke(this.method, what, storesToSearch);
  }

};
